import React, { CSSProperties, FC, useEffect, useMemo } from "react";
/* import { Spinner } from "@chakra-ui/react";
 */import "./Loader.scss";
import { useTranslation } from "react-i18next";

interface ILoader {
  label?: string;
  style?: CSSProperties;
  className?: string;
  children?: React.ReactNode;
}

const Loader: FC<ILoader> = ({
  label = "loading",
  style = {},
  children,
  className = "",
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    document.body.style.overflowY = "hidden";
    return () => {
      document.body.style.overflowY = "auto";
    };
  }, []);
  return (
    <div className={`loader_page ${className}`} style={{ ...style }}>
      <div className="loader_container">
       {/*  <Spinner
          thickness="12px"
          speed="1s"
          emptyColor="gray.200"
          color="blue.500"
          style={{ width: "11rem", height: "11rem" }}
        />
        {children ? (
          <>{children}</>
        ) : (
          <h1 className="in-progress-title">{t(label)}</h1>
        )} */}
      </div>
    </div>
  );
};

export default Loader;
